import * as T from "@shared/types";
import { axios } from ".";

const PAYOUT_BASE_URL = "/api/v1/payments";

export const getInvoiceDetails = async () => {
  //Testing purpose
  const start = new Date();
  start.setMonth(start.getMonth() - 8);
  const startDate = start.toISOString();
  const endDate = new Date().toISOString();
  const params = { startDate, endDate };
  const response = await axios.get<T.PurchaseOrderInvoiceResponse>(`${PAYOUT_BASE_URL}/invoices`, { params });
  return response.data.data;
};
